import { ICianMFUIElement } from '@cian/mf-registry/browser';

import * as React from 'react';

type TUseAdBannerMicrofrontend = {
  microfrontendRef: React.RefObject<ICianMFUIElement | null>;
  isReady: boolean;
};

/**
 * Задерживает монтирование микрофронтенда до клиента: реклама не должна рендериться на SSR,
 * иначе разметка сервера и браузера разойдётся.
 */
export function useAdBannerMicrofrontend(): TUseAdBannerMicrofrontend {
  const microfrontendRef = React.useRef<ICianMFUIElement | null>(null);
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    const timeout = setTimeout(() => setIsReady(true), 0);

    return () => clearTimeout(timeout);
  }, []);

  return { isReady, microfrontendRef };
}
